import { Card, CardContent } from '@repo/shadcn';

import { LoadingSpinner } from '@/components/loaders';
import { useGetTodayBalanceQuery } from '@/features/slice/balance-history/balance-history-api-slice';
import { formatCurrencyInBDT } from '@/utils';
import { DateFormatter } from '@/utils/date-formatter.util';

import { EditBalanceDialog } from './edit-balance-dialog.component';

export const CashBoxSummary = () => {
    const { data: today, isLoading } = useGetTodayBalanceQuery();

    if (isLoading) {
        return (
            <Card>
                <CardContent
                    className={'flex min-h-32 items-center justify-center p-4'}
                >
                    <LoadingSpinner />
                </CardContent>
            </Card>
        );
    }

    const summaryItems = [
        {
            label: "Today's Date",
            value: today ? DateFormatter.formatDate(today.date) : '—',
            tone: 'bg-slate-50',
            isText: true,
        },
        {
            label: 'Opening Balance',
            value: today
                ? formatCurrencyInBDT(Number(today.starting_balance))
                : '—',
            tone: 'bg-blue-50',
            isText: true,
        },
        {
            label: 'Cash In Hand',
            value: today
                ? today.ending_balance != null
                    ? formatCurrencyInBDT(Number(today.ending_balance))
                    : 'N/A'
                : '—',
            tone: 'bg-emerald-50',
            isText: true,
        },
    ];

    return (
        <Card>
            <CardContent className={'space-y-4 p-4'}>
                <div>
                    <h3 className={'text-lg font-medium'}>
                        Today&apos;s Cash Summary
                    </h3>
                    <p className={'text-sm text-muted-foreground'}>
                        Opening and closing balance for today.
                    </p>
                </div>

                <div className={'grid gap-3 md:grid-cols-3'}>
                    {summaryItems.map((item, index) => (
                        <div
                            key={item.label}
                            className={`relative rounded-xl border p-4 ${item.tone}`}
                        >
                            <p className={'text-sm text-muted-foreground'}>
                                {item.label}
                            </p>
                            <p
                                className={
                                    'mt-2 text-2xl font-semibold tracking-tight'
                                }
                            >
                                {item.value}
                            </p>

                            {today && index === 1 && (
                                // <button
                                //     className={
                                //         'absolute right-6 top-4 size-2 group-hover:opacity-100'
                                //     }
                                // >
                                //     <Edit className="size-4" />
                                // </button>
                                //
                                <EditBalanceDialog row={today} />
                            )}
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

CashBoxSummary.displayName = 'CashBoxSummary';
